<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.UpdateTaskLog') }}</h4>
        </div>
        <section class="col-12 mx-auto align-self-md-center">
            <div class="half-design row">
                <div class="col-12 form-block">
                    <div class="col-12 col-md-6 col-lg-5 mx-auto pt-5">
                        <b-form @submit.prevent="onSubmit">
                            <div class="mb-3 text-left">
                                <label class="mb-1" :class="serviceState" for="typeSelect">{{
                                    $t('title.SelectFrequency') }}</label>
                                <v-select id="type-select" v-model="formFields.typeSelect" :options="serviceOptions"
                                    size="sm" :placeholder="formFields.typeSelect.label">
                                </v-select>
                            </div>

                            <div class="mb-3 text-left">
                                <label for="name" class="mb-1" :class="nameState">{{
                                    $t('title.EnterTaskName') }}</label>
                                <b-form-input id="name" name="name" type="text" v-model="formFields.name"
                                    @input="validateName" :class="nameState"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('name')">
                                    {{ formErrors.first('name') }}
                                </b-form-invalid-feedback>
                                <!-- Show error message -->
                            </div>

                            <div class="mb-3 text-left">
                                <label for="description" class="mb-1" :class="descriptionState">
                                    {{ $t('title.EnterTaskdescription') }}
                                </label>
                                <b-form-textarea id="description" v-model="formFields.description"
                                    @input="validateDescription" :class="descriptionState"
                                    name="description"></b-form-textarea>

                                <b-form-invalid-feedback :state="!formErrors.has('description')">
                                    {{ formErrors.first('description') }}
                                </b-form-invalid-feedback>
                            </div>

                            <div class="mb-3 text-left">
                                <label for="start_time" class="mb-1 d-block" :class="startTimeState">
                                    {{ $t('title.EnterStartTime') }}
                                </label>
                                <vue-timepicker id="start_time" v-model="formFields.start_time" :manual-input="false"
                                    :minute-step="5" format="HH:mm" required class="d-block w-100"></vue-timepicker>
                                <b-form-invalid-feedback :state="!formErrors.has('start_time')">
                                    {{ formErrors.first('start_time') }}
                                </b-form-invalid-feedback>
                            </div>


                            <div class="mb-3 text-left">
                                <label for="end_time" class="mb-1" :class="endTimeState">
                                    {{ $t('title.EnterEndTime') }}
                                </label>
                                <vue-timepicker id="end_time" v-model="formFields.end_time" :manual-input="false"
                                    :minute-step="5" format="HH:mm" :disabled="endTimeDisabled" @input="validateEndTime"
                                    class="d-block w-100"></vue-timepicker>
                                <b-form-invalid-feedback :state="!formErrors.has('end_time')">
                                    {{ formErrors.first('end_time') }}
                                </b-form-invalid-feedback>
                            </div>


                            <div class="mb-3 text-left">
                                <label for="email" name="email" class="mb-1" :class="emailState">
                                    {{ $t('title.EnterEmail') }}
                                </label>
                                <b-form-input id="email" type="email" v-model="formFields.email" @input="validateEmail"
                                    :class="emailState" name="email"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('email')">
                                    {{ formErrors.first('email') }}
                                </b-form-invalid-feedback>
                            </div>

                            <div class="mb-3 text-left">
                                <label for="status" class="mb-1" :class="statusState">
                                    {{ $t('title.SelectStatus') }}
                                </label>
                                <v-select id="status" v-model="formFields.status" :class="statusState"
                                    :options="statusOptions" size="sm" required></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('status')">
                                    {{ formErrors.first('status') }}
                                </b-form-invalid-feedback>
                            </div>

                            <b-button type="submit" variant="primary" class="mb-3 w-100" :disabled="loader">
                                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader">
                                </div>
                                {{ $t('title.Submit') }}
                            </b-button>

                            <a class="text-center d-block mb-1" href="#" @click.prevent="onCancel">{{ $t('title.Cancel')
                                }}</a>

                            <b-form-invalid-feedback v-if="formErrors.general">{{ formErrors.general
                                }}</b-form-invalid-feedback>
                        </b-form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';

export default {
    data() {
        return {
            formFields: reactive({
                name: '',
                typeSelect: '',
                description: '',
                start_time: '',
                end_time: '',
                email: '',
                status: ''
            }),
            serviceOptions: [
                { label: this.$t('title.Daily'), value: 'D' },
                { label: this.$t('title.Hourly'), value: 'H' },
            ],
            statusOptions: [
                { label: this.$t('title.Active'), value: '1' },
                { label: this.$t('title.Inactive'), value: '0' },
            ],
            formErrors: new Error({}),
            endTimeDisabled: false,
        };
    },

    computed: {
        ...mapGetters(['loader']),
        nameState() {
            return this.formFields.name === '' ? '' : this.formErrors.name ? 'is-invalid' : 'is-valid';
        },
        statusState() {
            return this.formFields.status === null ? '' : this.formErrors.status ? 'is-invalid' : 'is-valid'; // Add computed for status
        },

        descriptionState() {
            return this.formFields.description === '' ? '' : this.formErrors.description ? 'is-invalid' : 'is-valid';
        },

        startTimeState() {
            return this.formFields.start_time === '' ? '' : this.formErrors.start_time ? 'is-invalid' : 'is-valid';
        },

        endTimeState() {
            return this.formFields.end_time === '' ? '' : this.formErrors.end_time ? 'is-invalid' : 'is-valid';
        },

        emailState() {
            return this.formFields.email === '' ? '' : this.formErrors.email ? 'is-invalid' : 'is-valid';
        },
        serviceState() {
            return this.formFields.typeSelect === '' ? '' : this.formErrors.typeSelect ? 'is-invalid' : 'is-valid';
        },
    },

    methods: {

        async fetchTaskData(id) {
            try {
                const response = await request({ method: 'get', url: `/admin/scheduled-task/${this.TaskId}` });
                const data = response.data;
                localStorage.setItem('taskData', JSON.stringify(data))
                this.formFields.name = data.name || "";
                this.formFields.typeSelect = this.serviceOptions.find(option => option.value === data.scheduled_type) || this.serviceOptions[0];
                this.formFields.start_time = data.start_time?.split(':').slice(0, 2).join(':') || "";
                this.formFields.end_time = data.end_time?.split(':').slice(0, 2).join(':') || "";
                this.formFields.description = data.description || "";
                this.formFields.email = data.email || "";
                this.formFields.status = data.is_active ? "Active" : "InActive" || "";

            } catch (error) {
                console.error('Error fetching Task data:', error);
            }
        },

        validateName() {
            const organizationName = this.formFields.name;
            if (typeof organizationName !== 'string') {
                this.formErrors.$errors.name = [this.$t('title.TaskNameRequired')];
                return;
            }
            if (!organizationName || organizationName.trim().length < 3) {
                this.formErrors.$errors.name = [this.$t('title.TaskNameMinLength')];
            } else {
                delete this.formErrors.$errors.name;
            }
        },

        validatescheduledtype() {
            const typeSelect = this.formFields.typeSelect;
            if (!typeSelect) {
                this.formErrors.$errors.typeSelect = [this.$t('title.serviceRequired')];
            } else {
                delete this.formErrors.$errors.typeSelect;
            }
        },

        validateDescription() {
            const description = this.formFields.description;
            this.formErrors.description = ''; // Clear previous errors
            if (description && description.length < 10) {
                this.formErrors.description = this.$t('errors.descriptionMinLength');
                this.descriptionState = 'is-invalid'; // Add error class
            } else {
                this.descriptionState = 'is-valid'; // Add success class
            }
        },

        validateStartTime() {
            this.formErrors.start_time = ''; // Clear previous errors
            const timePattern = /^([01]?[0-9]|2[0-3]):([0-5]?[0-9])$/; // Regex for 24-hour time format (e.g., 12:00, 13:00)

            if (!this.formFields.start_time) {
                this.formErrors.start_time = this.$t('errors.startTimeRequired');
            } else if (!timePattern.test(this.formFields.start_time)) {
                this.formErrors.start_time = this.$t('errors.invalidTimeFormat');
            }
        },

        validateEndTime() {
            if (!this.formFields.start_time || !this.formFields.end_time) {
                return; // Skip validation if either field is empty
            }

            const startTime = this.formFields.start_time.split(':').map(Number);
            const endTime = this.formFields.end_time.split(':').map(Number);

            const startMinutes = startTime[0] * 60 + startTime[1];
            const endMinutes = endTime[0] * 60 + endTime[1];

            if (endMinutes <= startMinutes) {
                this.formErrors.$errors.end_time = [this.$t('title.endTimeGreater')];
            } else {
                delete this.formErrors.$errors.end_time;
            }
        },

        validateEmail() {
            this.formErrors.email = ''; // Clear previous errors
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!this.formFields.email) {
                this.formErrors.email = this.$t('errors.emailRequired');
            } else if (!emailRegex.test(this.formFields.email)) {
                this.formErrors.email = this.$t('errors.invalidEmail');
            }
        },

        reloadPage() {
            this.$router.push({ name: 'scheduledTasks' });
        },

        async onSubmit() {
            const payload = {
                name: this.formFields.name,
                start_time: this.formFields.start_time,
                end_time: this.formFields.end_time,
                description: this.formFields.description,
                email: this.formFields.email,
                scheduled_type: this.formFields.typeSelect ? this.formFields.typeSelect.value : '',
                iis_active: this.formFields.status === "InActive" ? 0 : 1

            };
            try {
                const response = await request({
                    method: 'put',
                    url: `admin/scheduled-task/${this.TaskId}`,
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json',   // Content type for JSON data
                    }
                });

                const data = response;
                if (response['message'] && response['message'].includes("successfull") || response['code'] == 200) {
                    this.showToast();
                    setTimeout(() => {
                        this.reloadPage();
                    }, 1500);
                } else {
                    throw new Error(data.message || 'Error submitting form');
                }
            } catch (error) {
                this.formErrors = new Error({});

                if (error?.data?.errors) {
                    const errors = error.data.errors;
                    this.formErrors.$errors.name = errors.name ? errors.name : '';
                    this.formErrors.$errors.typeSelect = errors.scheduled_type ? errors.scheduled_type : '';
                    this.formErrors.$errors.start_time = errors.start_time ? errors.start_time : '';
                    this.formErrors.$errors.general = "Please fix the errors and try again.";
                    return false;

                } else {

                    this.formErrors.general = "Something went wrong. Please try again.";
                }
            }
        },

        showToast() {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
                this.$t('title.dataUpdated')
            ]);
            // Create the title
            const vNodesTitle = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, this.$t('title.dataUpdatedTitle'))]
            );
            // Pass the VNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: 'success',
            });
        },

        onCancel() {
            this.$router.push({ name: 'TaskLogs' });
        },
    },



    mounted() {
        const id = this.$route.params.id;
        this.TaskId = id;
        this.fetchTaskData(id);
    },


    watch: {
        'formFields.typeSelect'(newValue) {
            if (newValue.value === 'D') {
                this.formFields.end_time = ''; // Clear end_time when Daily is selected
                this.endTimeDisabled = true;  // Disable the field
            } else {
                this.endTimeDisabled = false; // Enable when not Daily
            }
        },

    },
    components: {
        VueTimepicker
    },


};
</script>
<style>
.vue__time-picker input.display-time {
    width: 100% !important;
}
</style>
